import AdminUsersIndex from './AdminUsersIndex';

export default AdminUsersIndex;
